import React from "react";
import {
  Dialog,
  DialogNavigation,
} from "../../../../../../components/modal/Dialog";
import { MessageThread } from "../../../../../messages/MessageThread";

export const StorefrontMessageDialog = ({
  active,
  onDismiss,
  relationshipId,
  supplierName,
}: {
  relationshipId: number;
  active: boolean;
  onDismiss: () => void;
  supplierName: string;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss} className={"overflow-hidden"}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={supplierName}
      />
      <MessageThread
        relationshipId={relationshipId}
        className={"min-h-[250px] md:h-auto"}
      />
    </Dialog>
  );
};
